export default "__VITE_ASSET__vLfCUSyL__"